// import { MobileStockInOutComponent } from './mobile/pages/mobile-batch-stock-in-out/mobile-batch-stock-in-out.component';
// import { WidgetMobileStockInOutComponent } from './mobile/widgets/widget-stock-in-out/widget-stock-in-out.component';
import { ConfigOption } from '@ngx-formly/core';
import { StoragePlaceDropdownComponent } from './controls/storage-place-dropdown/storage-place-dropdown.component';

export const WAREHOUSE_FORMLY_TYPES: ConfigOption['types'] = [
    { name: 'formly-storage-place-drop-down', component: StoragePlaceDropdownComponent, wrappers: ['simple-title'], },
]
